export class BibliotecaReservoir {
  static readonly BIBLIOTECA_LIBRARY = 'BIBLIOTECA_Biblioteca';
  static readonly BIBLIOTECA_PROVEEDORES = 'BIBLIOTECA_PROVEEDORES';

  static readonly GUIAS_DE_USO_CATEGORIES = 'GUIAS_DE_USO_CATEGORIES';
  static readonly GUIAS_DE_USO_ITEMS = 'GUIAS_DE_USO_ITEMS';

  static readonly DOCUMENTACION_INTERES_CATEGORIES = 'DOCUMENTACION_INTERES_CATEGORIES';
  static readonly DOCUMENTACION_INTERES_ITEMS = 'DOCUMENTACION_INTERES_ITEMS';

  static readonly PROVEEDORES_ITEMS = 'PROVEEDORES_ITEMS';
}
